"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    treeClassNames: function() {
        return treeClassNames;
    },
    useTreeStyles_unstable: function() {
        return useTreeStyles_unstable;
    }
});
const _react = require("@griffel/react");
const treeClassNames = {
    root: 'fui-Tree'
};
const useBaseStyles = /*#__PURE__*/ (0, _react.__resetStyles)("rnv2ez3", null, [
    ".rnv2ez3{display:flex;flex-direction:column;row-gap:var(--spacingVerticalXXS);}"
]);
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    subtree: {
        z8tnut: "fclwglc"
    }
}, {
    d: [
        ".fclwglc{padding-top:var(--spacingVerticalXXS);}"
    ]
});
const useTreeStyles_unstable = (state)=>{
    const baseStyles = useBaseStyles();
    const styles = useStyles();
    const isSubTree = state.level > 1;
    state.root.className = (0, _react.mergeClasses)(treeClassNames.root, baseStyles, isSubTree && styles.subtree, state.root.className);
    return state;
}; //# sourceMappingURL=useTreeStyles.styles.js.map
